export class UserRoles {
  public static CustomerSales = 'CustomerSales';
  public static ProductionOperator = 'ProductionOperator';
  public static MotionAdmin = 'MotionAdmin';
  public static MTLSEngineers = 'MTLSEngineers';
  public static CustomerSupport = 'CustomerSupport';
  public static ChiefPractitioner = 'ChiefPractitioner';
  public static Practitioner = 'Practitioner';

  public static addSpace(role: string) {
    const uppercases = role.match(/[A-Z]/g) || [];
    const lastUppercase = role.lastIndexOf(uppercases[uppercases.length - 1]);
    return role.slice(0, lastUppercase) + ' ' + role.slice(lastUppercase);
  }

  public static removeSpace(role: string) {
    return role.replace(/\s+/g, '');
  }

  public static isAdminRole(role: string) : boolean {
    const adminRoles = [UserRoles.MotionAdmin];
    return adminRoles.includes(role);
  }

  public static isMaterialiseRole(role: string) : boolean
  {
    const materialiseRoles = [UserRoles.MotionAdmin, UserRoles.MTLSEngineers];
    return materialiseRoles.includes(role);
  }
}